import { render, staticRenderFns } from "./BalanceIssues.vue?vue&type=template&id=009bc259&scoped=true&"
import script from "./BalanceIssues.vue?vue&type=script&lang=js&"
export * from "./BalanceIssues.vue?vue&type=script&lang=js&"
import style0 from "./BalanceIssues.vue?vue&type=style&index=0&id=009bc259&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009bc259",
  null
  
)

export default component.exports